import { render, staticRenderFns } from "./EconomicActivity.vue?vue&type=template&id=1e71ac64&scoped=true&"
import script from "./EconomicActivity.vue?vue&type=script&lang=ts&"
export * from "./EconomicActivity.vue?vue&type=script&lang=ts&"
import style0 from "./EconomicActivity.vue?vue&type=style&index=0&id=1e71ac64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e71ac64",
  null
  
)

export default component.exports